<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="group">
          <label>Item</label>
          <AjaxSelect
            v-model="workingItem"
            :api="`/api/entity/item/select`"
            :map-fn="(i) => i.name"
            :allow-empty-search="true"
            :query="{inventory: inventoryId}"
            :placeholder="$t('search')"
            :ignored="ignore"
          />
        </div>
      </div>

      <div class="column">
        <div class="group">
          <label>Direction</label>
          <select v-model="value.link">
            <option value="->">-></option>
            <option value="<-"><-</option>
            <option value="<>"><></option>
            <option value="--">--</option>
          </select>
        </div>
      </div>

    </div>
    <div class="group" v-if="hasRightArrowTextField">
      <LocalizedInput title="Text ->" :translate="workingTexts['->']"/>
    </div>
    <div class="group" v-if="hasLeftArrowTextField">
      <LocalizedInput title="Text <-" :translate="workingTexts['<-']"/>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import AjaxSelect from "@/components/tools/AjaxSelect";
import LocalizedInput from "@/components/tools/LocalizedInput";

export default {
  name: "CrossSellRow",
  components: {AjaxSelect, LocalizedInput},
  props: {
    value: Object,
    inventoryId: Number,
    ignore: Array,
    initialNameCache: Object,
  },

  data() {
    return {
      workingItem: {
        id: this.value.item,
        name: this.value.item ? (this.initialNameCache[this.value.item.toString()] || null) : null
      },
      workingTexts: {
        '->': this.value.text && this.value.text['->'] ? this.value.text['->'] : {},
        '<-': this.value.text && this.value.text['<-'] ? this.value.text['<-'] : {}
      }
    }
  },

  computed: {
    hasRightArrowTextField() {
      return this.value.link === '->' || this.value.link === '<>';
    },
    hasLeftArrowTextField() {
      return this.value.link === '<-' || this.value.link === '<>';
    }
  },

  watch: {
    "value.link": {
      immediate: true,
      handler(val) {
        /* inverse text */
        if (val === '->' && this.isEmptyObject(this.workingTexts['->']) && !this.isEmptyObject(this.workingTexts['<-'])) {
          Vue.set(this.workingTexts, '->', this.workingTexts['<-']);
          Vue.set(this.workingTexts, '<-', {});
        }
        else if (val === '<-' && this.isEmptyObject(this.workingTexts['<-']) && !this.isEmptyObject(this.workingTexts['->'])) {
          Vue.set(this.workingTexts, '<-', this.workingTexts['->']);
          Vue.set(this.workingTexts, '->', {});
        }
      }
    },
    "workingItem.id"(id) {
      this.value.item = id;
    },
    workingTexts: {
      deep: true,
      handler(newVal) {
        for (let [k, v] of Object.entries(newVal)) {
          let isEmpty = this.isEmptyObject(v);
          if (!this.value.text && !isEmpty) {
            Vue.set(this.value, 'text', {});
          }
          if (this.value.text) {
            Vue.set(this.value.text, k, isEmpty ? undefined : v);
          }
        }
        if (this.isEmptyObject(this.value.text)) {
          Vue.set(this.value, 'text', undefined);
        }
      }
    }
  },

  methods: {
    isEmptyObject(transObj) {
      return Object.values(transObj).filter(o => !!o).length === 0;
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
